import Axios from "axios";

import React, { useEffect } from "react";
import { FcSynchronize } from "react-icons/fc";
import Button from "../../atoms/Button/Button";
import styles from "./styles.module.css";
import version from "../../../version.json";
import { PROD, url } from "../../../utility/config";
import * as Sentry from "@sentry/react";

import StackTrace from "stacktrace-js";

const BASE_URL = url;

let timeout = null;
export const debounceWrapper = (func, time) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
        func();
    }, time);
};

export function ErrorPage({ userInfo, errorInfo }) {
    const { error, componentStack, resetError } = errorInfo;

    useEffect(() => {
        Sentry.captureException(error);

        const callback = (ee) => {
            if (process.env.NODE_ENV == "development") return;

            /**
             * @type {import("stacktrace-js").StackFrame}
             */
            const errorMeta = ee ? ee[0] : null;
            const errorInfo = errorMeta
                ? `${PROD ? "*PRODUCTION*" : "*TEST*"}
                   *Error* : ${error.message}
                   *File* : ${errorMeta.fileName}
                   *LineNumber* : ${errorMeta.lineNumber}
                   *Function* : ${errorMeta.functionName}
                   *Email* : ${userInfo.email}
                   *URL* : ${location.href}
                   *Version* : ${version.version}`
                : `${error.message}
                   ${componentStack}`;
            (async () => {
                Axios.post(
                    "https://chat-api.fuguchat.com/api/webhook?token=b5d0f0bd146d1a9db5541be2228d982961a6da06c040ce030646b86de7536a75",
                    {
                        data: {
                            message: errorInfo,
                        },
                    },
                );

                const res1 = await Axios({
                    url: "https://api.ipify.org?format=json",
                });

                Axios({
                    method: "post",
                    url: BASE_URL + "/api/dbApi/saveFrontendLogs",
                    data: {
                        error_message: errorInfo,
                        ip_address: res1?.data?.ip,
                        frontend_path: location.href,
                        browser: navigator.userAgent,
                        os: navigator.userAgent,
                        email: userInfo.email,
                        user_id: userInfo.userId,
                        country: userInfo.country,
                        time_zone: new Date().toUTCString(),
                        fe_version: version.version,
                        device_info: `${
                            window.innerHeight > window.innerWidth
                                ? "Mobile"
                                : "Desktop"
                        }(${window.innerHeight} x ${window.innerWidth})`,
                    },
                });
            })();
        };

        StackTrace.fromError(error)
            .then(callback)
            .catch((e) => console.log(e));

        document.getElementById("emailwecare")?.setAttribute("skip", true);
    }, []);

    return (
        <>
            <div className={styles.container}></div>
            <div className={styles.container1}>
                <h1> It’s not you, it’s us! </h1>
                <h3>
                    Please refresh the page using the button below to continue
                    using Scalenut.
                </h3>
                <p>
                    If the problem persists, let us know using Chat Support or
                    write us at&nbsp;
                    <a id="emailwecare" href="mailto: wecare@scalenut.com">
                        wecare@scalenut.com
                    </a>
                </p>

                <Button
                    handler={() => {
                        location.reload();
                    }}
                    text="Refresh"
                    Icon={FcSynchronize}
                    tertiary
                    width="200px"
                ></Button>
            </div>
        </>
    );
}
